export const environment = {
  production: true,
  API_ROOT: "https://api2.salonmonster.com/api",
  PHOTO_ROOT: "https://salonmonster.com/userfiles/booking_pics/",
  PROFILE_PHOTO_ROOT: "https://res.cloudinary.com/salonmonster/image/upload/w_1080/v1531352315/staff/",
  FACEBOOK_APP_ID: "426881094074823",
  GOOGLE_MAPS_API: "AIzaSyDWSq2r1PW_Eu3WGGLoo8a-qUBuQlQO6D8",
  stripePublishableKey: "pk_live_X4A4x8QX3dPsmCMErLrOZ97g",
};
